import { concatStyleSets, IRawStyle, ISearchBoxStyles } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontSizes, Sizes } from '../../themes/styles';

export const searchBoxStylesDefault = (theme: IH2OTheme): Partial<ISearchBoxStyles> => ({
  root: {
    height: 40,
    border: `1px solid ${theme.semanticColors?.inputBorder}`,
    borderRadius: Sizes.borderRadius,
    padding: 0,
    paddingLeft: 10,
    ':focus': {
      borderColor: theme.semanticColors?.inputActiveBorder,
    },
    '::after': {
      display: 'none',
    },
    '&.is-active': { borderColor: theme.semanticColors?.inputActiveBorder },
  },
  icon: {
    color: theme.semanticColors?.inputReadOnlyText,
    fontSize: FontSizes.textPrimary,
  },
  field: {
    fontSize: FontSizes.textPrimary,
    color: theme.semanticColors?.textQuaternary,
  },
  clearButton: {
    '.ms-Button:hover': {
      background: 'transparent',
    },
  },
});

const getUnderlineStyle = (theme: IH2OTheme): IRawStyle => ({
  border: 0,
  borderBottom: `1px solid ${theme.palette?.primary500}`,
  paddingLeft: 0,
  borderRadius: 0,
});

export const searchBoxStylesSearch = (theme: IH2OTheme): Partial<ISearchBoxStyles> => ({
  root: {
    height: 32,
    marginBottom: 0,
    paddingLeft: 12,
    '&.is-active': {
      ...getUnderlineStyle(theme),
      '.ms-SearchBox-iconContainer': { width: 0 },
    },
  },
});

export const searchBoxStylesSearchUnderline = (theme: IH2OTheme): Partial<ISearchBoxStyles> =>
  concatStyleSets(searchBoxStylesSearch(theme), {
    root: {
      ...getUnderlineStyle(theme),
      height: 40,
    },
  });
